<div class="page-padding">
	<div class="alert alert-warning" *ngIf="error">
		{{ error }}
	</div>

	<div class="alert alert-info" *ngIf="!users && !error">Laddar...</div>

	<mat-card>
		<mat-card-header>
			<mat-card-title>Användare</mat-card-title>
			<div class="card-header-toolbar right">
				<span class="badge badge-warning">Under utveckling</span>
			</div>
		</mat-card-header>
		<mat-card-content>
			<table class="table">
				<tr class="header">
					<td>E-post</td>
					<td>Namn</td>
					<td>Avdelning</td>
					<td>Anställning</td>
					<td>Bild</td>
				</tr>
				<tr *ngFor="let user of users">
					<td>{{ user.email }}</td>
					<td>
						<table-link path="users" [entity]="user"></table-link>
					</td>
					<td>{{ user.team?.name }}</td>
					<td>
						<div>{{ user.employer?.name }}</div>
						<div>{{ user.employeeID }}</div>
						<div class="contractor">{{ user.contractor?.supplierName }}</div>
						<div class="contractor">{{ user.contractor?.supplierNumber }}</div>
					</td>
					<td>
						<user-link [user]="user"></user-link>
					</td>
				</tr>
			</table>
		</mat-card-content>
	</mat-card>
</div>